import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { UsersService } from './../../shared/services/common/users.service';
import { CommonService } from './../../shared/services/common/common.service';
import { Component, OnInit } from '@angular/core';
import { CompositeFilterDescriptor, State } from '@progress/kendo-data-query';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-active-task',
  templateUrl: './active-task.component.html',
  styleUrls: ['./active-task.component.css']
})
export class ActiveTaskComponent implements OnInit {
  gridData: any;
  inputData: { userInfo: any; adjType: string };
  filters: CompositeFilterDescriptor;
  gridState: State = {
    sort: [],
    take: 10,
    skip: 0
  };

  constructor(
    private router: Router,
    private usersService: UsersService,
    private authService: AuthService,
    private commonService: CommonService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit(): void {
    this.inputData = {
      userInfo: this.usersService.UserInfo(),
      adjType: ''
    };
    this.notificationService.setUpLoading(true);
    this.getActiveTaskData();
  }

  getActiveTaskData() {
    this.inputData.adjType = 'Active';
    this.commonService.getTrackerTasks(this.inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200 && response.data && response.data.length > 0) {
        const activeData = response.data;
        activeData.forEach(element => {
          element.createdDate = new Date(element.createdDate);
          element.dueDate = new Date(element.dueDate);
        });
        this.gridData = activeData;
      } else if (response && response.statusCode === 204) {
        this.gridData = [];
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  redirectUser(dataItem: any) {
    const encryptValue = this.authService.encryptText(dataItem.uniqueId);
    sessionStorage.setItem('terminateUser', encryptValue);
    this.router.navigate([dataItem.navigationLink]);
  }

}
